import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	priorityTooltip: {
		id: 'platform-ui-card.common.priority.priority-tooltip',
		defaultMessage: '{priorityLevel} priority',
		description: 'Tooltip of the icon depicting the priority of the issue',
	},
});
